function openModal(width, height, onClose = null, blurBackground = true) {
  closeModal();
  const reference = document.createElement("div");
  reference.id = "modal";
  reference.style.width = width;
  reference.style.height = height;

  const closeBtn = document.createElement("span");
  closeBtn.classList.add("modal-close-btn");
  reference.appendChild(closeBtn);

  closeBtn.addEventListener("click", () => {
    closeModal();
  });

  if (onClose) {
    closeBtn.addEventListener("click", onClose);
  }

  const clickCapture = document.createElement("div");
  clickCapture.id = "modal-click-capture";
  if (blurBackground) {
    clickCapture.classList.add("blur");
  }
  clickCapture.onclick = closeModal;
  document.body.appendChild(clickCapture);

  document.body.appendChild(reference);

  return reference;
}

function closeModal() {
  let reference = document.getElementById("modal");
  if (reference) {
    reference.remove();
  }

  reference = document.getElementById("modal-click-capture");
  if (reference) {
    reference.remove();
  }
}

window.isModalOpen = () => {
  const reference = document.getElementById("modal");
  return reference == true;
};
